import L from 'leaflet'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

export const DEFAULT_MAP_CENTER = {lat: 33.8938, lng: 35.5018}

export const leafletMarkerIcon = new L.Icon({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
})

export function toMapPosition(center: {lat?: number; lng?: number} | null | undefined): [number, number] {
  const lat = Number(center?.lat)
  const lng = Number(center?.lng)

  if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
    return [DEFAULT_MAP_CENTER.lat, DEFAULT_MAP_CENTER.lng]
  }

  return [lat, lng]
}

export function hasValidMapCoordinates(center: {lat?: number; lng?: number} | null | undefined): boolean {
  const lat = Number(center?.lat)
  const lng = Number(center?.lng)

  return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)
}
